/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDriverRating.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/driver-rating";

export class AutogenModelDriverRating<RowType extends ModelRow> extends Endpoint<RowType, RowDriverRatingFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDriverRating extends ModelRow<RowDriverRatingFields> {
	constructor(values?: Partial<RowDriverRatingFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDriverRatingFields {
	company_id: string;
	descr: string;
	id: string;
	is_active: string;
}

